// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XWjH","option":"styles_option__3P2z6","active":"styles_active__3QRXf"};